import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ProgressBarDescriptions from "../ProgressBarDescriptions";
import SubscoreProgressBar from "../../SubscoreProgressBar";
import CircleProgressChart from "../ReportDescCirlceChart";

// const DetailsContainer = styled.div`
//   background: #fff;
//   border: none;
//   padding: 1.5rem 3rem 2rem 3rem;
//   margin: 0 0 1rem 0;
//   border-radius: 8px;
//   box-shadow: 0 4px 8px rgba(0,0,0,0.1);

//   @media (max-width: 1024px) {
//     border-bottom: 1px solid #e9ecef;
//     padding: 1rem 2rem;
//     width: 100%;
//     border-radius: none;
//     box-shadow: none;
//   }
// `;

const DetailsContainerBordeless = styled.div`
  background: #fff;
  border: none;
  padding: 0rem 3rem 2rem 3rem;
  margin: 0;
  border-radius: 8px;

  @media (max-width: 1024px) {
    border-bottom: none;
    padding: 0rem 2rem;
    width: 100%;
    border-radius: none;
    box-shadow: none;
  }
`;

const Headline = styled.h4`
  font-size: 1.2rem;
  margin-bottom: 10px;
`;

const Description = styled.p`
  font-size: 16px;
`;

const HealthParametersDetails = ({ data = {}, classesTwo, t }) => {
  const { name, score, categories, bonus } = data;
  const [bonusScore, setBonusScore] = useState(0);
  const [totalScore, setTotalScore] = useState(0);

  useEffect(() => {
    if (bonus !== null) setBonusScore(bonus?.value);
  }, [bonus]);

  useEffect(() => {
    const totalScore = (score || 0) + (bonusScore || 0);
    const adjustedScore = Math.min(totalScore, 100);
    setTotalScore(adjustedScore);
  }, [score, bonusScore]);

  const HeadlineTwoText = () => {
    return (
      <>
        <Description>
          {t("Våra matval spelar en avgörande roll för vår hälsa och välbefinnande. En hälsosam kost minskar risken att drabbas av livsstilssjukdomar som t ex obesitas, typ 2-diabetes, hjärt-kärlsjukdom och vissa cancerformer. Sjukdomarna innebär stort lidande för de drabbade och medför en belastning för hela samhället.")}
        </Description>
      </>
    );
  };

  const DescriptionText = () => (
    <Description>
      {t("Consupedias hälsopoäng anges på en skala från 1–100, ju högre poäng, desto bättre för hälsan. Värdet grundar sig på produktens näringsvärde jämfört med andra livsmedelsprodukter i vår databas där ett högt värde betyder att produkten är nyttig och näringsrik.")}
    </Description>
  );

  return (
    <DetailsContainerBordeless className={classesTwo}>
      <ProgressBarDescriptions
        name={name}
        score={score}
        bonus={bonus}
        t={t}
      />
      <CircleProgressChart name={name} score={totalScore} reductionFactor={0.30} isScore={false} mtop={16} mbottom={16} t={t} />
      <div>
        <Headline>
          {t("Hälsovärde")} {totalScore} {t("av 100")}
        </Headline>
        <DescriptionText />
      </div>
      {categories?.map((category, index) => (
        <SubscoreProgressBar category={category} index={index} key={category.name} t={t} />
      ))}
      <HeadlineTwoText />
    </DetailsContainerBordeless>
  );
};

export default HealthParametersDetails;
